import { sample } from 'effector';
import { debounce } from 'patronum';
import { format } from 'date-fns';
import { $pathname } from '@features/common';
import { deleteSavedFilters, filterNameForm } from '@features/toolbarFilter/model';
import { fxGetTicketList, PageGate, path } from '../page';
import {
  fxSetMetrics,
  metricsTimeout,
  setMetricsFilterCreated,
  setMetricsFilterDeleted,
  setMetricsListOpened,
  setMetricsListRequested,
} from './model';
import { MetricEvents, metricEvents } from './types';

const getMetrics = (event: MetricEvents) => ({
  metrics: [{ event, at: format(new Date(), 'yyyy-MM-dd HH:mm:ss') }],
});

sample({
  clock: debounce({
    source: setMetricsListOpened,
    timeout: metricsTimeout,
  }),
  target: fxSetMetrics,
});

sample({
  clock: debounce({
    source: setMetricsListRequested,
    timeout: metricsTimeout,
  }),
  target: fxSetMetrics,
});

sample({
  clock: debounce({
    source: setMetricsFilterCreated,
    timeout: metricsTimeout,
  }),
  target: fxSetMetrics,
});

sample({
  clock: debounce({
    source: setMetricsFilterDeleted,
    timeout: metricsTimeout,
  }),
  target: fxSetMetrics,
});

const events = () => {
  sample({
    clock: PageGate.open,
    fn: () => getMetrics(metricEvents.tck_tickets_list_opened),
    target: setMetricsListOpened,
  });

  sample({
    clock: fxGetTicketList.done,
    fn: () => getMetrics(metricEvents.tck_tickets_list_requested),
    target: setMetricsListRequested,
  });

  sample({
    clock: filterNameForm.submitted,
    source: $pathname,
    filter: (pathname) => `/${pathname.split('/')[1]}` === path,
    fn: () => getMetrics(metricEvents.tck_tickets_filter_created),
    target: setMetricsFilterCreated,
  });

  sample({
    clock: deleteSavedFilters,
    source: $pathname,
    filter: (pathname) => `/${pathname.split('/')[1]}` === path,
    fn: () => getMetrics(metricEvents.tck_tickets_filter_deleted),
    target: setMetricsFilterDeleted,
  });
};

events();
